import { combineReducers } from 'redux';
import soleProprietorshipForm1099MISCand1099NECReducer from './SoleProprietorshipForm1099MISCand1099NEC/slice';
import saleofOtherAssetsReducer from './SaleofOtherAssets/slice';


export default combineReducers({
  soleProprietorshipForm1099MISCand1099NEC : soleProprietorshipForm1099MISCand1099NECReducer,  
saleofOtherAssets : saleofOtherAssetsReducer,  

});
